<template>
  <div class="sky-login">
    <div class="sky-login__header">
      <span @click="goDashboard"
        ><img
          class="sky-login__logo-img"
          src="@/assets/images/logo/logo.png"
          srcset="@/assets/images/logo/logo@2x.png 2x"
      /></span>

      <!-- <span class="sky-login__header-text">{{ $t('login.switchAccount') }}</span> -->
    </div>
    <div class="sky-login__main">
      <el-card body-style="padding: 0;">
        <div class="sky-login__main-large-box">
          <!-- <div class="sky-login__main-left-box">
            <imgShow />
          </div> -->
          <div class="sky-login__main-right-box">
            <slot />
          </div>
        </div>
      </el-card>
    </div>
    <div class="sky-login__footer">
      <span class="sky-login__footer-txt">{{ $t('login.browserSupport') }}</span>
      <span class="sky-login__footer-line">|</span>
      <span class="sky-login__footer-txt">{{ $t('login.technologyScupport') }}</span>
      <span class="sky-login__footer-line">|</span>
      <span class="sky-login__footer-txt">{{ $t('login.contact') }}</span>
      <span class="sky-login__footer-line">|</span>
      <span class="sky-login__footer-txt">{{ $t('login.company') }}</span>
      <span class="sky-login__footer-line">|</span>
      <span class="sky-login__footer-txt">{{ $t('login.keepOnRecord') }}</span>
    </div>
  </div>
</template>
<script>
import { Card } from 'element-ui'

export default {
  name: 'LoginLayer',
  components: {
    [Card.name]: Card
  },
  methods: {
    goDashboard() {
      window.location.href = '/#/'
    }
  }
}
</script>
